module.exports = __webpack_public_path__ + "static/media/RedTick.1595ba3c.svg";